import React from "react";

// auth
import ConfirmMail from "../views/dashboard/auth/confirm-mail";
import LockScreen from "../views/dashboard/auth/lock-screen";
import Recoverpw from "../views/dashboard/auth/recoverpw";
import SignIn from "../views/dashboard/auth/sign-in";
import SignUp from "../views/dashboard/auth/sign-up";

// errors
import Error404 from "../views/dashboard/errors/error404";
import Error500 from "../views/dashboard/errors/error500";

//extrpages
import Maintenance from "../views/dashboard/extrapages/maintenance";
import ComingSoon from "../views/dashboard/extrapages/comingsoon";
import InstagramError from "../components/InstagramError/InstagramError";
import Resetpassword from "../views/dashboard/auth/resetpassword";
import Contact from "../pages/Contact";
import Pricing from "../pages/Pricing";
import Landing from "../pages/Landing";
import Help from "../pages/Help";

import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ResetPassword from "../pages/auth/ResetPassword";
import RecoverPassword from "../pages/auth/RecoverPassword";
import PrivacyPolicy from "../pages/privacy-policy";
import Documention from "../pages/Documention/Documention";
import Doc from "../pages/Documention";
import FacebookTopics from "../pages/Documention/facebook/Topics";
import InstagramAutomation from "../pages/Documention/facebook/SubQuestion/instagram-automation";
import AutoReplyComments from "../pages/Documention/facebook/SubQuestion/auto-reply-comments";
import AutoReplyStoryReplies from "../pages/Documention/facebook/SubQuestion/auto-reply-story-replies";
import AutoReplyStoryMention from "../pages/Documention/facebook/SubQuestion/auto-reply-story-mention";
import ConversationStarters from "../pages/Documention/facebook/SubQuestion/conversation-starters";
import BotPersistentMenu from "../pages/Documention/facebook/SubQuestion/bot-persistent-menu";
import FaVerify from "../pages/auth/2fa-verify";
import AutoReplyMessage from "../pages/Documention/facebook/SubQuestion/auto-reply-message";
import Introduction from "../pages/Docs/introduction";
import QuickStart from "../pages/Docs/quick-start";
import MainFeature from "../pages/Docs/main-feature";

import Index from "../views/dashboard";
import Settingssocialmedia from "../views/dashboard/Settingssocialmedia/Settingssocialmedia";
import FacebookError from "../components/facebookError/FacebookError";
import Support from "../pages/Docs/support";
import AiIntegration from "../pages/Docs/ai-integration";
import AdditionalFeature from "../pages/Docs/main-feature";
import QuickReply from "../pages/Docs/quick-reply";
import Security from "../pages/Docs/security";
import ManagingDashboard from "../pages/Docs/managing-dashboard";
import VerifyEmail from "../pages/auth/VerifyEmail";

export const SimpleRouter = [
  {
    path: "auth/confirm-mail",
    element: <ConfirmMail />,
  },
  {
    path: "/aaa",
    element: <Index />,
  },
  {
    path: "auth/lock-screen",
    element: <LockScreen />,
  },
  {
    path: "auth/recover-password",
    element: <RecoverPassword />,
  },
  {
    path: "auth/resetpassword/:id",
    element: <ResetPassword />,
  },
  {
    path: "auth/sign-in",
    element: <Login />,
  },
  {
    path: "auth/sign-in",
    element: <Login />,
  },
  {
    path:"auth/2fa-verify",
    element:<FaVerify/>
  },
  {
    path: "auth/verify-email",
    element: <VerifyEmail />,
  },
  {
    path: "auth/sign-up",
    element: <Register />,
  },
  {
    path: "errors/error404",
    element: <Error404 />,
  },
  {
    path: "errors/error500",
    element: <Error500 />,
  },
  {
    path: "/instagram-error",
    element: <InstagramError />,
  },
  {
    path: "/facebook-error",
    element: <FacebookError />,
  },
  {
    path: "extra-pages/pages-maintenance",
    element: <Maintenance />,
  },
  {
    path: "extra-pages/pages-comingsoon",
    element: <ComingSoon />,
  },
  {
    path: "extra-pages/pages-comingsoon",
    element: <ComingSoon />,
  },
  {
    path: "pages/contact-us",
    element: <Contact />,
  },
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "pages/pricing",
    element: <Pricing />,
  },
  {
    path: "pages/about",
    element: <Help />,
  },
  {
    path: "pages/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "pages/documention",
    element: <Doc />,
    children: [
      {
        path: "Introduction",
        // index: true, // This makes it the default route for "pages/documentation"
        element: <Introduction />,
      },
      {
        path: "quick-start",
        element: <QuickStart />,
      },
      {
        path: "additional-feature",
        element: <AdditionalFeature />,
      },
      {
        path: "ai-integration",
        element: <AiIntegration />,
      },
      {
        path: "quick-reply",
        element: <QuickReply />,
      },

      {
        path: "support-troubleshooting",
        element: <Support />,
      },
      {
        path: "managing-dashboard",
        element: <ManagingDashboard />,
      },
      {
        path: "security",
        element: <Security />,
      },
      {
        path: "facebook",
        element: <FacebookTopics />,
      },
    ]
  },

  {
    path: "pages/documention/facebook/auto-reply-comments",
    element: <AutoReplyComments />,
  },
  {
    path: "pages/documention/facebook/auto-reply-comments",
    element: <AutoReplyComments />,
  },
  {
    path: "pages/documention/facebook/auto-reply-story-replies",
    element: <AutoReplyStoryReplies />,
  },
  {
    path: "pages/documention/facebook/auto-reply-story-mention",
    element: <AutoReplyStoryMention />,
  },
  {
    path: "pages/documention/facebook/auto-reply-message",
    element: <AutoReplyMessage />,
  },
  {
    path: "pages/documention/facebook/conversation-starters",
    element: <ConversationStarters />,
  },
  {
    path: "pages/documention/facebook/bot-persistent-menu",
    element: <BotPersistentMenu />,
  }
];
